var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.548,
    height: 14.548,
    viewBox: "0 0 14.548 14.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M13.639,8.416a.727.727,0,0,0-.727.727v5.223a.727.727,0,0,1-.727.727h-8a.727.727,0,0,1-.727-.727v-8a.727.727,0,0,1,.727-.727H9.405a.727.727,0,0,0,0-1.455H4.182A2.182,2.182,0,0,0,2,6.365v8a2.182,2.182,0,0,0,2.182,2.182h8a2.182,2.182,0,0,0,2.182-2.182V9.143A.727.727,0,0,0,13.639,8.416ZM16.49,2.451A.739.739,0,0,0,15.821,2H11.456a.727.727,0,0,0,0,1.455h2.611L6.575,10.94a.73.73,0,1,0,1.033,1.033L15.094,4.48V7.092a.727.727,0,0,0,1.455,0V2.727a.727.727,0,0,0-.058-.276Z",
    transform: "translate(-2 -2)",
    fill: "#3b76f7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.f4983c0796d085fe50b4caab24d48095.svg";
export { ForwardRef as ReactComponent };